// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"_46ORnXiU","sectionTitle":"_2e6RhDe-","divisor":"vC9lI3qa"};